import { __ } from "@wordpress/i18n";

// Get plugin URL from global variable with fallback
const pluginUrl = window.cocaBaisDashboard?.pluginUrl || "";

// Define image paths with fallbacks - avoiding any undefined property access
const getImagePath = (imageName) => {
    // Try multiple paths to find the working one
    const paths = [
        // Path 1: Direct from plugin URL to assets/lib/images
        pluginUrl + "assets/lib/images/" + imageName + ".png",
        // Path 2: Try src/lib/images path
        pluginUrl + "src/lib/images/" + imageName + ".png",
    ];
    
    // Return the first non-empty path
    return paths.find((path) => path && path.length > 0) || "";
};

const WelcomeHeader = () => {
    return (
        <section className="coca__welcome">
            <div className="container">
                <div className="welcome-wrapper">
                    <div className="text-content">
                        <h1>
                            <span>Welcome to</span> <br />
                            <strong>Before After Slider</strong>
                        </h1>
                        <p>
                            Now, you can easily create stunning visual comparisons and engage your visitors like never
                            before. Get started by creating your first slider and watch how powerful visual storytelling
                            can instantly communicate value to your audience.
                        </p>
                        <a
                            href={window.cocaBaisDashboard?.adminUrl + "post-new.php?post_type=coca_bais"}
                            className="add-slider-button"
                        >
                            Add New Slider
                        </a>
                    </div>
                    <div className="video-thumbnail">
                        <div className="video-wrapper">
                            <img
                                src={getImagePath("video-banner")}
                                alt={__("Video Banner", "wp-before-after-image-slider-pro")}
                            />
                            <a href="https://www.youtube.com/watch?v=eeCM0E2ggMo" target="_blank"> 
                                <div className="play-button">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="white"
                                        viewBox="0 0 24 24"
                                        width="24"
                                        height="24"
                                    >
                                        <path d="M8 5v14l11-7z" />
                                    </svg>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WelcomeHeader;
